
<div
  class="relative border border-[#DAE1E4] flex items-center rounded-full
         px-4
         focus-within:border-blue-500
         focus-within:ring-2 focus-within:ring-blue-100 transition" [ngClass]="extraClass">

  <input
    type="text"
    [(ngModel)]="searchTerm"
    [placeholder]="placeholder | translate"
    class="flex-1 py-3 ltr:pr-8 placeholder:text-(--text-muted)
           text-base leading-6 text-(--text-primary)
           outline-none bg-transparent lg:max-w-full max-w-[95%]"
    (input)="onSearch(searchTerm)"
    (click)="$event.stopPropagation()"
  />

  <!-- Search icon -->
  <img
    *ngIf="!searchTerm"
    src="assets/icons/search.svg"
    alt="search"
    class="w-4 h-4 absolute right-4 rtl:left-4 rtl:right-auto pointer-events-none"
  /> 

  <!-- Clear icon -->
  <button
    *ngIf="searchTerm"
    type="button"
    (click)="removeSearch($event)"
    class="absolute ltr:right-4 rtl:left-4 rtl:right-auto
           w-6 h-6 rounded-full flex items-center justify-center
           hover:opacity-80 bg-(--bg-color)">
    <img src="assets/icons/cancel-black.svg" alt="clear" />
  </button>

</div>
